import { useStore } from '../store';
import { fmtMoney } from '../bridge';

const NOTE = 'white-space:normal;text-transform:none;letter-spacing:0.01em';
const money = (n: number): string => `${n < 0 ? '-' : ''}$${fmtMoney(Math.abs(n))}`;

/** Existing advisor scenario, not a new economy model or guaranteed cash forecast. */
export function ForecastPanel() {
  const { sim, openPanel } = useStore();
  const f = sim.forecast;
  const horizon = f ? f.curveCents.length - 1 : 0;
  return (
    <div style="padding:6px 14px 16px">
      <div class="eyebrow eyebrow-rule">Forecast - spending scenario</div>
      <div class="card" style="margin-top:10px;padding:12px 16px">
        <div class="row-label">Cash on hand</div>
        <div class="row-value" style="font-size:18px">{money(sim.cashCents)}</div>
        {!f && <div class="row-label" style={`${NOTE};margin-top:8px`}>The current worker has not provided a spending scenario. No estimate is shown.</div>}
        {f && <>
          <div class="row-label" style={`${NOTE};margin-top:10px`}>Modeled scenario balance at day {horizon}</div>
          <div class="row-value" style="font-size:18px">{money(f.endpointCents)}</div>
          <div class="row-label" style={`${NOTE};margin-top:8px`}>{sim.cashCents < 0 ? 'Cash is already below zero.' : f.cashRunwayDays === null ? 'No wages or herd-feed spending in the current runway model.' : `Cash covers ${f.cashRunwayDays.toLocaleString('en-US')} game days of listed wages and baseline herd feed. This runway excludes loan interest.`}</div>
          <details style="margin-top:10px">
            <summary>Daily scenario balances ({horizon} game days)</summary>
            {f.curveCents.map((value, day) => <div key={day} class="row" style="margin:0;padding:5px 0"><span class="row-label">{day === 0 ? 'Today' : `In ${day} game day${day === 1 ? '' : 's'}`}</span><span>{money(value)}</span></div>)}
          </details>
        </>}
      </div>
      <div class="row-label" style={`${NOTE};margin-top:10px`}>Spending scenario only, not a prediction or guaranteed minimum. The existing model holds today's listed wages and baseline herd-feed cost constant, before research discounts or age adjustments and subtracts an allowance for current loan interest. Interest actually accrues to loan principal, so this allowance is not a scheduled cash debit.</div>
      <div class="row-label" style={`${NOTE};margin-top:8px`}>It does not simulate future income, sales, contracts, purchases, loan payments, taxes, insurance premiums, facility upkeep, changing herd needs or market changes. Use Finance for actual recorded income and expenses.</div>
      <button class="btn btn-quiet" style="width:100%;margin-top:10px" onClick={() => { openPanel({ kind: 'office', section: 'finance' }); }}>Open finance</button>
    </div>
  );
}
